import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { UpdateFirmMetaForm } from "./UpdateFirmMetaForm";
import { FirmLicences } from "../firmLicences/FirmLicences";
import { getFirmDetails } from "@/sideEffects/api";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router";
import { ROUTES } from "@/constants/routeConstants";
import { useBreadcrumbs } from "@/hooks/useBreadcrumbs";
import { useTranslation } from "react-i18next";
import { LoadingSmall } from "@/components/LoadingSmall";
import { DeleteFirmButton } from "../DeleteFirmButton";
import { BaseFormLayout } from "@/pages/shared/BaseFormLayout";
import { FirmUserAdmins } from "./FirmUserAdmins";

export const FirmDetailPage = () => {
  const { t } = useTranslation();
  const [queryParams] = useSearchParams();
  const firmId = queryParams.get("Id");

  const { data: firmDetails, isLoading } = useQuery({
    queryKey: ["getFirmDetails", firmId],
    queryFn: () => getFirmDetails(Number(firmId)),
    enabled: !!firmId,
  });

  const firmDetailsData = firmDetails?.data;

  useBreadcrumbs([
    {
      name: t("entities.firm"),
      path: ROUTES.FIRM,
    },
    {
      name: firmDetailsData ? `${t("common.entityDetail", { name: firmDetailsData?.name })}` : "...",
      path: ROUTES.FIRM_DETAIL,
    },
  ]);

  if (!firmDetailsData || isLoading) {
    return (
      <div className="flex justify-center items-center h-full p-16">
        <LoadingSmall />
      </div>
    );
  }

  return (
    <BaseFormLayout
      title={t("common.entityDetail", { name: firmDetailsData.name })}
      rightContent={<DeleteFirmButton firmId={firmDetailsData.id} />}
    >
      <Tabs defaultValue="detail">
        <TabsList>
          <TabsTrigger value="detail">{t("common.detail")}</TabsTrigger>
          <TabsTrigger value="licences">{t("firm.licences")}</TabsTrigger>
          <TabsTrigger value="userAdmins">{t("firm.userAdmins")}</TabsTrigger>
        </TabsList>
        <TabsContent value="detail">
          <UpdateFirmMetaForm firmDetails={firmDetailsData} />
        </TabsContent>
        <TabsContent value="licences">
          <FirmLicences firmGuid={firmDetailsData.firmGuid} firmId={firmDetailsData.id} />
        </TabsContent>
        <TabsContent value="userAdmins">
          <FirmUserAdmins firmGuid={firmDetailsData.firmGuid} />
        </TabsContent>
      </Tabs>
    </BaseFormLayout>
  );
};
